<template>
  <FullPageLayout class="relative">
    <template v-if="fetchState.pending">
      <div>loading...</div>
    </template>
    <template v-else-if="fetchState.error">
      <ErrorPageLayout :error="fetchState.error" />
    </template>
    <template v-else>
      <YazioBrands />
      <YazioHeader>
        <div class="flex items-center sm:flex-row flex-col text-center sm:text-left">
          <YazioAuthorImage :item="authorInfo" width="130" height="130" class="rounded-full yazio-author-avatar sm:mr-6" />
          <div class="flex flex-col text-white">
            <h1 class="sm:text-32 text-24 font-bold">{{ authorInfo.name }}</h1>
            <p class="sm:text-24 text-xl">{{ authorInfo.title }}</p>
            <YazioSocialMedias :author="authorInfo" />
          </div>
        </div>
      </YazioHeader>
      <div class="sm:w-[1100px] w-full mx-auto">
        <YazioWidget v-if="authorInfo.bio" icon="hakkinda" title="Hakkında" class="mt-6 px-4 sm:px-0 text-sm text-primary-100">
          <div class="whitespace-pre-line">
            <span>{{ authorInfo.bio }}</span>
          </div>
        </YazioWidget>
        <YazioWidget icon="son-yazilar" title="Tüm İçerikler" class="mt-6 px-4 sm:px-0"></YazioWidget>
        <div class="flex flex-wrap items-stretch">
          <YazioArticle
            v-for="article in authorArticles"
            :key="article._id"
            :article="article"
            class="w-full sm:w-[350px] sm:ml-0 sm:mr-4 mb-4 sm:mb-6"
          />
        </div>
        <div v-if="hasNextPage" ref="yazioArticlesEndRef" class="mt-6 sm:mb-24 mb-36 u-center">
          <OLoading v-if="loading" />
        </div>
      </div>
    </template>
  </FullPageLayout>
</template>
<script>
import FullPageLayout from '@/modules/common/components/layout/FullPageLayout';
import ErrorPageLayout from '@/modules/common/components/layout/ErrorPageLayout.vue';
import YazioBrands from '@/modules/yazio/components/YazioBrands';
import YazioHeader from '@/modules/yazio/components/YazioHeader';
import YazioWidget from '@/modules/yazio/components/YazioWidget';
import YazioArticle from '@/modules/yazio/components/YazioArticle';
import YazioSocialMedias from '@/modules/yazio/components/YazioSocialMedias';
import YazioAuthorImage from '@/modules/yazio/components/YazioAuthorImage';
import { defineComponent, useFetch, useContext, ref, useRoute, useMeta, ssrRef } from '@nuxtjs/composition-api';
import { useInfiniteScroll } from '~/composables/useInfiniteScroll';
import OLoading from '~/modules/common/components/ui/OLoading/OLoading';
import { HOST_URL, IS_ONEDIO } from '~/constants/config';

export default defineComponent({
  components: {
    FullPageLayout,
    ErrorPageLayout,
    YazioBrands,
    YazioHeader,
    YazioWidget,
    YazioArticle,
    YazioSocialMedias,
    YazioAuthorImage,
    OLoading,
  },
  head: {},
  setup() {
    const { $error, $service, $cache } = useContext();
    const authorInfo = ref({});
    const authorArticles = ref([]);
    const loading = ref(false);
    const hasNextPage = ssrRef(false);
    const fetchPage = ref(1);
    const route = useRoute();
    const slug = route.value.params.slug;
    const path = route.value.path;
    $cache('public, max-age=30');
    const { fetch, fetchState } = useFetch(async () => {
      try {
        if (!IS_ONEDIO) {
          $error('Page not found', 404, false);
        }
        const { data } = await $service.yazio.getYazioAuthorBySlug(slug);
        if (!data) {
          $error('User not found', 404, false);
        }
        const {
          data: articles,
          pagination: { hasNextPage: hasNextPageData },
        } = await $service.yazio.getYazioAuthorArticles(data._id, fetchPage.value);
        authorInfo.value = data;
        authorArticles.value = articles;
        hasNextPage.value = hasNextPageData;
      } catch (error) {
        $error(error);
      }
    });
    useMeta(() => {
      return {
        title: authorInfo.value?.name && authorInfo.value?.name + ' - Onedio Yazio',
        meta: authorInfo.value?.name && [
          {
            hid: 'description',
            name: 'description',
            content: `${authorInfo.value?.name}, Yazio'da sizler için yazıyor! yazarın öne çıkan içerikleri ve daha fazlası için hemen tıklayın.`,
          },
        ],
        bodyAttrs: { class: 'yazio-background' },
        link: [{ hid: 'canonical', rel: 'canonical', href: HOST_URL + path }],
      };
    });
    const [yazioArticlesEndRef] = useInfiniteScroll(async () => {
      if (hasNextPage.value) {
        loading.value = true;
        fetchPage.value = fetchPage.value + 1;
        const {
          data: articles,
          pagination: { hasNextPage: hasNextPageData },
        } = await $service.yazio.getYazioAuthorArticles(authorInfo.value._id, fetchPage.value);
        hasNextPage.value = hasNextPageData;
        authorArticles.value = [...authorArticles.value, ...articles];
        loading.value = false;
      }
    });
    return { fetch, fetchState, authorInfo, authorArticles, yazioArticlesEndRef, hasNextPage, loading };
  },
});
</script>
<style lang="scss">
.yazio-author-avatar {
  border: 5px solid rgba(255, 255, 255, 0.1);
}
.yazio-background {
  background: #f7f8fb;
}
.yazio-header-title {
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);
}
</style>
